import { Subject } from '../Subject';
import { Subscription } from '../Subscription';
import { lift } from '../util/lift';
export function repeatWhen(notifier) {
    return function (source) { return lift(source, function (source) {
        var subscriber = this;
        var subscription = new Subscription();
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var getCompletionSubject = function () {
            if (!completions$) {
                completions$ = new Subject();
                var notifier$ = void 0;
                try {
                    notifier$ = notifier(completions$);
                }
                catch (err) {
                    subscriber.error(err);
                    return null;
                }
                subscription.add(notifier$.subscribe({
                    next: function () {
                        if (innerSub) {
                            subscribeForRepeatWhen();
                        }
                        else {
                            syncResub = true;
                        }
                    },
                    error: function (err) { return subscriber.error(err); },
                    complete: function () {
                        isNotifierComplete = true;
                        if (isMainComplete) {
                            subscriber.complete();
                        }
                    },
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function () {
            isMainComplete = false;
            innerSub = source.subscribe({
                next: function (value) { return subscriber.next(value); },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    isMainComplete = true;
                    if (isNotifierComplete) {
                        subscriber.complete();
                    }
                    else {
                        var completions$_1 = getCompletionSubject();
                        if (completions$_1) {
                            completions$_1.next();
                        }
                    }
                },
            });
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
            else {
                subscription.add(innerSub);
            }
        };
        subscribeForRepeatWhen();
        return subscription;
    }); };
}
//# sourceMappingURL=repeatWhen.js.map